module.exports = __webpack_public_path__ + "img/满山红.f2229982.jpg";